<div>
  @if (fmHotDoc) {
    <rask-hot-doc
      [hotDoc]="fmHotDoc">
    </rask-hot-doc>
  }

  <div>
    <button id="clearCellButton" class="btn fordelningsmatris-btn-rensa" (click)="clearCell()" [disabled]="!isCellSelected">{{texts.btnRensa}}</button>
    <button id="setForbjudenButton" class="btn fordelningsmatris-btn-forbjuden" (click)="setForbjuden()" [disabled]="!isCellSelected">{{texts.btnForbjuden}}</button>
    <button id="setMinButton" class="btn fordelningsmatris-btn-min" (click)="setMin()" [disabled]="!isCellSelected">{{texts.btnMin}}</button>
    <button id="setMaxButton" class="btn fordelningsmatris-btn-max" (click)="setMax()" [disabled]="!isCellSelected">{{texts.btnMax}}</button>
    <rask-button aid="copy" class="btn fordelningsmatris-btn-kopiera" color="secondary" icon="fas fa-clipboard" (click)="copyRader()">Kopiera rader</rask-button>
  </div>
  <div class="row">
    <rask-button
      aid="genereraFranLangdmodulerButton"
      class="pt-0"
      color="secondary"
      (click)="genereraFranLangdmoduler()"
      [disabled]="!canGenereraFranLangdmoduler">
      {{texts.btnGenereraLangdmoduler}}
    </rask-button>
    <rask-label class="col-12 col-lg-12 generera-fran-langdmoduler-label" for="genereraFranLangdmodulerBtn">{{texts.genereraFranLangdmodulerHelpText}}</rask-label>

  </div>
</div>
